// Daily Output · Data check — the panel's strings in the portal's four languages (2026-10-21).
const en = {
  title: 'Data check',
  meta: '{{vendor}} · {{from}} – {{to}} · {{rows}} rows · last sheet {{last}}',
  period: 'Period',
  nDays: '{{n}} days',
  checkAgain: 'Check again',
  checking: 'Checking…',
  aiTitle: "The AI's one-line reading of the findings below — the findings themselves are the portal's arithmetic",
  aiDidNotRun: 'The AI did not run ({{err}}). The findings below are the check itself.',
  noSummary: 'No summary. The findings below are the check itself.',
  nothingToFix: 'Nothing to fix in this period.',
  levelUnreliable: 'Unreliable',
  levelCheck: 'Check',
  levelInfo: 'Info',
  headNoTime_one: '{{count}} row with pieces but no workers or no hours — nothing about time can be read off it.',
  headNoTime_other: '{{count}} rows with pieces but no workers or no hours — nothing about time can be read off them.',
  headLongDay_one: '{{count}} line-day whose hours add up to more than {{max}} — the same hours written against two items.',
  headLongDay_other: '{{count}} line-days whose hours add up to more than {{max}} — the same hours written against two items.',
  headEvenSplit_one: '{{count}} line-day where different items carry exactly the same time a piece — the hours were divided evenly, not recorded.',
  headEvenSplit_other: '{{count}} line-days where different items carry exactly the same time a piece — the hours were divided evenly, not recorded.',
  headUnmatched_one: "{{count}} row in the factory's file not attached to an order — it is in no figure.",
  headUnmatched_other: "{{count}} rows in the factory's file not attached to an order — they are in no figure.",
  headNoSheet_one: '{{count}} working day with no sheet, up to the last day imported.',
  headNoSheet_other: '{{count}} working days with no sheet, up to the last day imported.',
  pcs: '{{n}} pcs',
  noWorkers: 'no workers',
  noHours: 'no hours',
  noWorkersHours: 'no workers and hours',
  noWhat: 'no {{what}}',
  rowsPcs_one: '{{count}} row · {{pcs}} pcs',
  rowsPcs_other: '{{count}} rows · {{pcs}} pcs',
  noSheet: 'no sheet',
  perPiece: '{{m}} min {{s}} s a piece',
  perPieceMin: '{{m}} min a piece',
  openDay: "Open this day's sheet",
  showFewer: 'Show fewer',
  more: '+{{n}} more',
  checkCol: 'Check',
  rowOutput: 'Output',
  rowWorkers: 'Workers',
  rowHours: 'Hours',
  rowMatched: 'Matched to an order',
  cellOk: 'In and complete',
  cellBad: 'Needs fixing',
  cellNone: 'No sheet that day',
  cellLater: 'Not imported yet',
  sunday: 'Sunday',
  legendOk: 'in and complete',
  legendBad: 'needs fixing',
  legendNone: 'no sheet',
  legendLater: "not imported yet — the vendors' files are imported, the last day on file is {{last}}",
  nothingFound: 'Nothing found in {{n}} days.',
  wd: { sun: 'Sun', mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat' },
};

const ko = {
  title: '데이터 점검',
  meta: '{{vendor}} · {{from}} – {{to}} · {{rows}}행 · 마지막 시트 {{last}}',
  period: '기간',
  nDays: '{{n}}일',
  checkAgain: '다시 점검',
  checking: '점검 중…',
  aiTitle: 'AI가 아래 점검 결과를 한 줄로 읽은 것입니다 — 점검 결과 자체는 포털의 계산입니다',
  aiDidNotRun: 'AI가 실행되지 않았습니다({{err}}). 아래 점검 결과가 점검 그 자체입니다.',
  noSummary: '요약 없음. 아래 점검 결과가 점검 그 자체입니다.',
  nothingToFix: '이 기간에는 고칠 것이 없습니다.',
  levelUnreliable: '신뢰 불가',
  levelCheck: '확인 필요',
  levelInfo: '참고',
  headNoTime_one: '수량은 있지만 작업자나 시간이 없는 행 {{count}}개 — 시간에 관해서는 아무것도 읽을 수 없습니다.',
  headNoTime_other: '수량은 있지만 작업자나 시간이 없는 행 {{count}}개 — 시간에 관해서는 아무것도 읽을 수 없습니다.',
  headLongDay_one: '시간 합계가 {{max}}시간을 넘는 라인-일 {{count}}건 — 같은 시간이 두 아이템에 기록되었습니다.',
  headLongDay_other: '시간 합계가 {{max}}시간을 넘는 라인-일 {{count}}건 — 같은 시간이 두 아이템에 기록되었습니다.',
  headEvenSplit_one: '서로 다른 아이템의 개당 시간이 정확히 같은 라인-일 {{count}}건 — 시간을 기록한 것이 아니라 균등하게 나눈 것입니다.',
  headEvenSplit_other: '서로 다른 아이템의 개당 시간이 정확히 같은 라인-일 {{count}}건 — 시간을 기록한 것이 아니라 균등하게 나눈 것입니다.',
  headUnmatched_one: '공장 파일에서 오더에 연결되지 않은 행 {{count}}개 — 어떤 수치에도 들어가지 않습니다.',
  headUnmatched_other: '공장 파일에서 오더에 연결되지 않은 행 {{count}}개 — 어떤 수치에도 들어가지 않습니다.',
  headNoSheet_one: '마지막으로 가져온 날까지 시트가 없는 근무일 {{count}}일.',
  headNoSheet_other: '마지막으로 가져온 날까지 시트가 없는 근무일 {{count}}일.',
  pcs: '{{n}}개',
  noWorkers: '작업자 없음',
  noHours: '시간 없음',
  noWorkersHours: '작업자·시간 없음',
  noWhat: '{{what}} 없음',
  rowsPcs_one: '{{count}}행 · {{pcs}}개',
  rowsPcs_other: '{{count}}행 · {{pcs}}개',
  noSheet: '시트 없음',
  perPiece: '개당 {{m}}분 {{s}}초',
  perPieceMin: '개당 {{m}}분',
  openDay: '이 날의 시트 열기',
  showFewer: '접기',
  more: '+{{n}}개 더',
  checkCol: '점검',
  rowOutput: '생산량',
  rowWorkers: '작업자',
  rowHours: '시간',
  rowMatched: '오더 연결',
  cellOk: '입력 완료',
  cellBad: '수정 필요',
  cellNone: '그날 시트 없음',
  cellLater: '아직 가져오지 않음',
  sunday: '일요일',
  legendOk: '입력 완료',
  legendBad: '수정 필요',
  legendNone: '시트 없음',
  legendLater: '아직 가져오지 않음 — 벤더 파일을 가져오며, 파일상 마지막 날은 {{last}}입니다',
  nothingFound: '{{n}}일 동안 발견된 것이 없습니다.',
  wd: { sun: '일', mon: '월', tue: '화', wed: '수', thu: '목', fri: '금', sat: '토' },
};

const vi = {
  title: 'Kiểm tra dữ liệu',
  meta: '{{vendor}} · {{from}} – {{to}} · {{rows}} dòng · sheet cuối {{last}}',
  period: 'Kỳ',
  nDays: '{{n}} ngày',
  checkAgain: 'Kiểm tra lại',
  checking: 'Đang kiểm tra…',
  aiTitle: 'Nhận định một dòng của AI về các phát hiện bên dưới — bản thân các phát hiện là phép tính của portal',
  aiDidNotRun: 'AI không chạy ({{err}}). Các phát hiện bên dưới chính là kết quả kiểm tra.',
  noSummary: 'Không có tóm tắt. Các phát hiện bên dưới chính là kết quả kiểm tra.',
  nothingToFix: 'Không có gì cần sửa trong kỳ này.',
  levelUnreliable: 'Không tin cậy',
  levelCheck: 'Cần xem',
  levelInfo: 'Thông tin',
  headNoTime_one: '{{count}} dòng có số lượng nhưng không có công nhân hoặc giờ — không đọc được gì về thời gian.',
  headNoTime_other: '{{count}} dòng có số lượng nhưng không có công nhân hoặc giờ — không đọc được gì về thời gian.',
  headLongDay_one: '{{count}} chuyền-ngày có tổng giờ vượt {{max}} — cùng số giờ bị ghi cho hai mặt hàng.',
  headLongDay_other: '{{count}} chuyền-ngày có tổng giờ vượt {{max}} — cùng số giờ bị ghi cho hai mặt hàng.',
  headEvenSplit_one: '{{count}} chuyền-ngày mà các mặt hàng khác nhau có thời gian mỗi sản phẩm giống hệt nhau — giờ được chia đều, không phải ghi nhận thực tế.',
  headEvenSplit_other: '{{count}} chuyền-ngày mà các mặt hàng khác nhau có thời gian mỗi sản phẩm giống hệt nhau — giờ được chia đều, không phải ghi nhận thực tế.',
  headUnmatched_one: '{{count}} dòng trong file của nhà máy chưa gắn với đơn hàng nào — không nằm trong số liệu nào.',
  headUnmatched_other: '{{count}} dòng trong file của nhà máy chưa gắn với đơn hàng nào — không nằm trong số liệu nào.',
  headNoSheet_one: '{{count}} ngày làm việc không có sheet, tính đến ngày cuối đã nhập.',
  headNoSheet_other: '{{count}} ngày làm việc không có sheet, tính đến ngày cuối đã nhập.',
  pcs: '{{n}} sp',
  noWorkers: 'không có công nhân',
  noHours: 'không có giờ',
  noWorkersHours: 'không có công nhân và giờ',
  noWhat: 'không có {{what}}',
  rowsPcs_one: '{{count}} dòng · {{pcs}} sp',
  rowsPcs_other: '{{count}} dòng · {{pcs}} sp',
  noSheet: 'không có sheet',
  perPiece: '{{m}} phút {{s}} giây mỗi sản phẩm',
  perPieceMin: '{{m}} phút mỗi sản phẩm',
  openDay: 'Mở sheet của ngày này',
  showFewer: 'Thu gọn',
  more: '+{{n}} nữa',
  checkCol: 'Kiểm tra',
  rowOutput: 'Sản lượng',
  rowWorkers: 'Công nhân',
  rowHours: 'Giờ',
  rowMatched: 'Gắn với đơn hàng',
  cellOk: 'Đã nhập đủ',
  cellBad: 'Cần sửa',
  cellNone: 'Ngày này không có sheet',
  cellLater: 'Chưa nhập',
  sunday: 'Chủ nhật',
  legendOk: 'đã nhập đủ',
  legendBad: 'cần sửa',
  legendNone: 'không có sheet',
  legendLater: 'chưa nhập — file của nhà cung cấp được nhập vào, ngày cuối trong file là {{last}}',
  nothingFound: 'Không phát hiện gì trong {{n}} ngày.',
  wd: { sun: 'CN', mon: 'T2', tue: 'T3', wed: 'T4', thu: 'T5', fri: 'T6', sat: 'T7' },
};

const zh = {
  title: '数据检查',
  meta: '{{vendor}} · {{from}} – {{to}} · {{rows}} 行 · 最后一张表 {{last}}',
  period: '期间',
  nDays: '{{n}} 天',
  checkAgain: '重新检查',
  checking: '检查中…',
  aiTitle: 'AI 对下方检查结果的一句话解读——检查结果本身是门户的计算',
  aiDidNotRun: 'AI 未运行（{{err}}）。下方的检查结果即为检查本身。',
  noSummary: '无摘要。下方的检查结果即为检查本身。',
  nothingToFix: '此期间无需修正。',
  levelUnreliable: '不可靠',
  levelCheck: '需检查',
  levelInfo: '提示',
  headNoTime_one: '{{count}} 行有数量但没有工人或工时——无法从中读出任何时间信息。',
  headNoTime_other: '{{count}} 行有数量但没有工人或工时——无法从中读出任何时间信息。',
  headLongDay_one: '{{count}} 个产线日的工时合计超过 {{max}}——同一工时被记在了两个品项上。',
  headLongDay_other: '{{count}} 个产线日的工时合计超过 {{max}}——同一工时被记在了两个品项上。',
  headEvenSplit_one: '{{count}} 个产线日中不同品项的单件时间完全相同——工时是平均分摊的，而非实际记录。',
  headEvenSplit_other: '{{count}} 个产线日中不同品项的单件时间完全相同——工时是平均分摊的，而非实际记录。',
  headUnmatched_one: '工厂文件中有 {{count}} 行未关联到订单——不计入任何数字。',
  headUnmatched_other: '工厂文件中有 {{count}} 行未关联到订单——不计入任何数字。',
  headNoSheet_one: '截至最后导入日，有 {{count}} 个工作日没有表。',
  headNoSheet_other: '截至最后导入日，有 {{count}} 个工作日没有表。',
  pcs: '{{n}} 件',
  noWorkers: '无工人',
  noHours: '无工时',
  noWorkersHours: '无工人和工时',
  noWhat: '无{{what}}',
  rowsPcs_one: '{{count}} 行 · {{pcs}} 件',
  rowsPcs_other: '{{count}} 行 · {{pcs}} 件',
  noSheet: '无表',
  perPiece: '每件 {{m}} 分 {{s}} 秒',
  perPieceMin: '每件 {{m}} 分',
  openDay: '打开当天的表',
  showFewer: '收起',
  more: '+{{n}} 条',
  checkCol: '检查',
  rowOutput: '产量',
  rowWorkers: '工人',
  rowHours: '工时',
  rowMatched: '已关联订单',
  cellOk: '已录入且完整',
  cellBad: '需修正',
  cellNone: '当天无表',
  cellLater: '尚未导入',
  sunday: '周日',
  legendOk: '已录入且完整',
  legendBad: '需修正',
  legendNone: '无表',
  legendLater: '尚未导入——供应商的文件为导入数据，文件中最后一天为 {{last}}',
  nothingFound: '{{n}} 天内未发现问题。',
  wd: { sun: '周日', mon: '周一', tue: '周二', wed: '周三', thu: '周四', fri: '周五', sat: '周六' },
};

const dictionary = { ns: 'xOutCheck', en, ko, vi, zh };

export default dictionary;
